"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Box;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireDefault(require("react"));

var _SpruceClassName = _interopRequireDefault(require("stampy/lib/util/SpruceClassName"));

function remify(rems) {
  return rems && typeof rems === 'string' ? rems.trim().split(' ').join('rem ') + 'rem' : undefined;
}

function Box(props) {
  var children = props.children;
  var className = props.className;
  var _props$element = props.element,
      Element = _props$element === void 0 ? 'div' : _props$element;
  var marginBottom = props.marginBottom;
  var marginLeft = props.marginLeft;
  var marginRight = props.marginRight;
  var marginTop = props.marginTop;
  var margin = props.margin;
  var modifier = props.modifier;
  var paddingBottom = props.paddingBottom;
  var paddingLeft = props.paddingLeft;
  var paddingRight = props.paddingRight;
  var paddingTop = props.paddingTop;
  var padding = props.padding;
  var parent = props.parent;
  var _props$spruceName = props.spruceName,
      spruceName = _props$spruceName === void 0 ? 'Box' : _props$spruceName;
  var style = props.style;
  var _props$boxProps = props.boxProps,
      boxProps = _props$boxProps === void 0 ? {} : _props$boxProps;
  return _react.default.createElement(Element, (0, _extends2.default)({
    className: (0, _SpruceClassName.default)({
      name: spruceName,
      modifier: modifier,
      className: className,
      parent: parent
    }),
    children: children
  }, boxProps, {
    style: (0, _objectSpread2.default)({}, style, {
      margin: remify(margin),
      marginBottom: remify(marginBottom),
      marginLeft: remify(marginLeft),
      marginRight: remify(marginRight),
      marginTop: remify(marginTop),
      padding: remify(padding),
      paddingBottom: remify(paddingBottom),
      paddingLeft: remify(paddingLeft),
      paddingRight: remify(paddingRight),
      paddingTop: remify(paddingTop)
    })
  }));
}